import classnames from 'classnames';
import React from 'react';
import { getErrorInfo } from './helpers';
import { Field } from 'redux-form';

function getDisabledPart({ input }) {
  return (
    <span className={classnames('new-design-field', 'sub-class-disabled')}>
      {input.value}
    </span>
  );
}

function getInputPart({ input, ...p }) {
  return (
    <input
      className="new-design-field"
      type={p.type}
      placeholder={p.placeholder}
      autoComplete={p.autoComplete}
      {...input}
    />
  );
}

function textField({ meta, ...p }) {
  return (
    <div className="scope-field-container">
      <div className="scope-field-label">{p.label} *</div>
      {p.disabled ? getDisabledPart(p) : getInputPart(p)}
      {getErrorInfo(meta)}
    </div>
  );
}

/**
 * @param {object} props
 * @param {string} [props.name]
 * @param {*} [props.label]
 * @param {boolean} [props.disabled]
 * @param {string} [props.placeholder]
 * @param {string} [props.autoComplete]
 * @param {string} [props.type='text']
 */
function TextField({ name, type = 'text', ...props }) {
  return <Field name={name} {...props} type={type} component={textField} />;
}

export default TextField;
